import ModelService from "./abstract/ModelService";
import ApiToken from "../models/ApiToken";

export default class ApiTokenService extends ModelService {
  constructor() {
    super('/api-tokens', ApiToken);
  }
}
